/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-globals */
import React, { useState, Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Select, Upload, Alert, notification,
} from 'antd';
import { H3_TITLE } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ForecastActions from '@Actions/application/forecastActions';
import { Column, Line } from '@ant-design/plots';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faWarning, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import './style.scss';
import { LoadingOutlined } from '@ant-design/icons';

const { Option } = Select;

/**
 *
 */
function ForecastAnalysis({
  user, startForecast, startForecastLoading,
  selectedForecast, getForecastResults,
}) {
  const [isUserReady, setIsUserReady] = useState(false);

  useEffect(() => {
    if (!isUserReady) {
      setIsUserReady(true);
    }
  }, [isUserReady]);
  const monthMapping = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
  };
  const weekdayMapping = {
    0: 'Mon',
    1: 'Tue',
    2: 'Wed',
    3: 'Thu',
    4: 'Fri',
    5: 'Sat',
    6: 'Sun',
  };
  const wekendMapping = {
    0: 'Weekday',
    1: 'Weekend',
  };
  const getConfig = (values, dataType) => {
    const getMappingType = (key) => {
      if (dataType === 'AVG_MONTH') return monthMapping[key];
      if (dataType === 'AVG_WEEKDAY') return weekdayMapping[key];
      if (dataType === 'AVG_WEEKEND') return wekendMapping[key];
    };
    const getMappingTypeForQuantity = (row) => {
      if (row?.month) return monthMapping[row?.month];
      if (row?.year) return row?.year;
      if (row?.weekday >= 0) return weekdayMapping[row?.weekday];
    };
    const config = {
      data: selectedForecast?.target === 'sales' ? Object.keys(values)?.map((key) => ({
        type: ['AVG_MONTH_DAY', 'AVG_YEAR', 'AVG_STORE'].includes(dataType) ? key : getMappingType(key),
        sales: Number(values[key]?.toFixed(2)),
      })) : values?.filter?.((item) => item?.item?.toLowerCase() !== 'others')?.map((row) => ({
        type: getMappingTypeForQuantity(row),
        sales: row?.quantity,
        item: row?.item,
      })),
      xField: 'type',
      yField: 'sales',
      seriesField: 'item',
      label: false,
      columnWidthRatio: 0.8,
      legend: {
        position: 'right',
      },
      // isPercent: selectedForecast?.target === 'quantity',
      isStack: selectedForecast?.target === 'quantity',
      xAxis: {
        label: {
          autoHide: true,
          autoRotate: false,
        },
      },
      yAxis: {
        label: {
          autoHide: true,
          autoRotate: false,
        },
      },
      meta: {
        sales: {
          alias: 'Sales',
        },
      },
    };
    if (selectedForecast?.target !== 'quantity') {
      config.color = () => '#2d7cf7';
    }
    return config;
  };

  /**
     *
     */
  return (
    <div className="forecast-form__processed-data">
      <H3Text
        text={(
          <div className="flex-display">
            <H3Text text={`#${selectedForecast?.forecast_number} ${selectedForecast?.forecast_name}`} className="forecast-form__processed-header__title-text" />
            {selectedForecast?.status === 'DATA_PROCESSED' && (
              <div className="forecast-form__processed-header__title-status">
                <FontAwesomeIcon icon={faCircleCheck} />
                                &nbsp;Data Processing Successful
              </div>
            )}
            {selectedForecast?.status === 'DATA_PROCESSING_FAILED' && (
              <div className="forecast-form__processed-header__title-status">
                <FontAwesomeIcon icon={faWarning} style={{ color: 'red' }} />
                                &nbsp;Data Processing Failed
              </div>
            )}
            {selectedForecast?.status === 'TRAINING_FAILED' && (
              <div className="forecast-form__processed-header__title-status">
                Data Forecasting Failed&nbsp;
                <FontAwesomeIcon icon={faWarning} style={{ color: 'red' }} />
              </div>
            )}
            {['FILE_READ_FROM_BLOB', 'TRAINING_STARTED', 'PRE_PROCESSING_FOR_TRAINING', 'EVALUATION_DONE'].includes(selectedForecast?.status) && (
              <div className="forecast-form__processed-header__title-status">
                <LoadingOutlined style={{ color: '#2D7DF7', fontSize: '18px' }} />
                &nbsp;
                Please wait. Your forecast will be ready in a few minutes
                {/* <FontAwesomeIcon icon={faWarning} style={{ color: 'red' }} /> */}
              </div>
            )}
          </div>
        )}
        className="forecast-form__processed-header__title"
      />
      {selectedForecast?.visualisation_data && (
        <Fragment>
          <H3Text text="Here is a quick overview of your past sales!" className="forecast-form__processed-header__subtitle" />
          <div className="ant-row">
            <div className={selectedForecast?.target === 'quantity' ? 'ant-col-md-24' : 'ant-col-md-8'}>
              <div className="forecast-form__processed-data__line-chart" style={{ height: selectedForecast?.target === 'quantity' ? '405px' : '225px', marginRight: selectedForecast?.target === 'quantity' ? '0px' : '10px' }}>
                <H3Text text="Average Monthly Sales" className="forecast-form__processed-data__chart-text" />
                <div className="forecast-form__processed-data__line-chart-inner" style={{ height: selectedForecast?.target === 'quantity' ? '300px' : '135px' }}>
                  <Column {...getConfig(selectedForecast?.visualisation_data?.avg_sales_bar_graphs?.month || selectedForecast?.visualisation_data?.monthly_data, 'AVG_MONTH')} />
                </div>
              </div>
            </div>
            <div className={selectedForecast?.target === 'quantity' ? 'ant-col-md-12' : 'ant-col-md-8'}>
              <div className="forecast-form__processed-data__line-chart" style={{ width: selectedForecast?.target === 'quantity' ? 'calc(100% - 10px)' : 'calc(100% - 5px)', height: selectedForecast?.target === 'quantity' ? '325px' : '225px', marginRight: selectedForecast?.target === 'quantity' ? '0px' : '10px' }}>
                <div className="forecast-form__processed-data__chart-text">
                  Average Sales on Weekdays
                </div>
                <div className="forecast-form__processed-data__line-chart-inner" style={{ height: selectedForecast?.target === 'quantity' ? '235px' : '135px' }}>
                  <Column {...getConfig(selectedForecast?.visualisation_data?.avg_sales_bar_graphs?.weekday || selectedForecast?.visualisation_data?.weekday_data, 'AVG_WEEKDAY')} />
                </div>
              </div>
            </div>
            <div className={selectedForecast?.target === 'quantity' ? 'ant-col-md-12' : 'ant-col-md-8'}>
              <div className="forecast-form__processed-data__line-chart" style={{ height: selectedForecast?.target === 'quantity' ? '325px' : '225px', marginRight: selectedForecast?.target === 'quantity' ? '0px' : '10px' }}>
                <div className="forecast-form__processed-data__chart-text">
                  Average Yearly Sales
                </div>
                <div className="forecast-form__processed-data__line-chart-inner" style={{ height: selectedForecast?.target === 'quantity' ? '235px' : '135px' }}>
                  <Column {...getConfig(selectedForecast?.visualisation_data?.avg_sales_bar_graphs?.year || selectedForecast?.visualisation_data?.yearly_data, 'AVG_YEAR')} />
                </div>
              </div>
            </div>
            {selectedForecast?.target !== 'quantity' && (
              <div className="ant-col-md-8">
                <div className="forecast-form__processed-data__line-chart">
                  <div className="forecast-form__processed-data__chart-text">
                    Average Sales on Weekends
                  </div>
                  <div className="forecast-form__processed-data__line-chart-inner">
                    <Column {...getConfig(selectedForecast?.visualisation_data?.avg_sales_bar_graphs?.weekend, 'AVG_WEEKEND')} />
                  </div>
                </div>
              </div>
            )}
            {selectedForecast?.target !== 'quantity' && (
              <div className="ant-col-md-8">
                <div className="forecast-form__processed-data__line-chart" style={{ marginLeft: '5px' }}>
                  <div className="forecast-form__processed-data__chart-text">
                    Average Sales on Days of Month
                  </div>
                  <div className="forecast-form__processed-data__line-chart-inner">
                    <Line {...getConfig(selectedForecast?.visualisation_data?.avg_sales_by_day_of_month_line_chart, 'AVG_MONTH_DAY')} />
                  </div>
                </div>
              </div>
            )}
            {selectedForecast?.target !== 'quantity' && (
              <div className="ant-col-md-8">
                <div className="forecast-form__processed-data__line-chart" style={{ marginLeft: '10px' }}>
                  <div className="forecast-form__processed-data__chart-text">
                    Average Sales per Store
                  </div>
                  <div className="forecast-form__processed-data__line-chart-inner">
                    <Column {...getConfig(selectedForecast?.visualisation_data?.avg_sales_by_store_pie_chart, 'AVG_STORE')} />
                  </div>
                </div>
              </div>
            )}
            <div className="ant-col-md-4">
              <H3Button
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                text="Begin Forecasting"
                onClick={() => startForecast({
                  forecast_id: selectedForecast?.forecast_id,
                }, () => {
                })}
                isLoading={startForecastLoading}
                disabled={startForecastLoading || !['DATA_PROCESSED', 'DATA_PROCESSING_FAILED'].includes(selectedForecast?.status)}
                style={{
                  width: '180px',
                  borderRadius: '5px',
                  padding: '10px 0px',
                  marginLeft: '0',
                }}
              />
            </div>
          </div>
        </Fragment>
      )}
      {selectedForecast?.status === 'DATA_PROCESSING_FAILED' && !selectedForecast?.visualisation_data && (
        <div className="forecast-form__processing-error">
          <FontAwesomeIcon icon={faTriangleExclamation} />
          <H3Text text="Oops, something seems to have gone wrong. Please try again." className="forecast-form__processing-error-message" />
          <H3Text
            text={(
              <span>
                If this issue persists, please&nbsp;
                <a href="mailto:support@procuzy.com" target="_blank" rel="noreferrer">contact support</a>
                .
              </span>
            )}
            className="forecast-form__processing-error-contact"
          />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = ({
  UserReducers, ForecastReducers,
}) => ({
  user: UserReducers.user,
  selectedForecast: ForecastReducers.selectedForecast,
  startForecastLoading: ForecastReducers.startForecastLoading,
});

const mapDispatchToProps = (dispatch) => ({
  startForecast: (payload, callback) => dispatch(ForecastActions.startForecast(payload, callback)),
});

ForecastAnalysis.propTypes = {
  user: PropTypes.any,
  selectedForecast: PropTypes.func,
  startForecastLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForecastAnalysis));
